import { Box, Flex } from '@chakra-ui/layout';
import {
  Button,
  IconButton,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  UseDisclosureProps,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';
import { ProgressBar } from './Step';

type ConfigureInvestmentsProps = {
  modalProps: UseDisclosureProps;
};

export const ConfigureInvestments: React.FC<ConfigureInvestmentsProps> = ({ modalProps }) => {
  const model = useSurveyBannerModel();

  return (
    <ModalContent>
      <ModalHeader
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}>
        Configure Investor Type
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="times" />}
          onClick={modalProps.onClose}
        />
      </ModalHeader>
      <ModalBody>
        <Flex flex={1} gap="24px" p={'24px'} justifyContent={'space-between'} flexDirection={'column'} display={'flex'}>
          <Box w={'50%'} m={'auto'}>
            <Image image={'configure-investor-animation'} />
          </Box>
          <Box mt={'24px'} w={'100%'}>
            <TextBlock
              mr={'10px'}
              fontSize={'12px'}
              whiteSpace="nowrap"
              color={'blue.500'}
              weight="bold">{`Step 1 of 4`}</TextBlock>
            <TextBlock whiteSpace="nowrap" weight="bold">
              Configure Investor Type
            </TextBlock>
            <ProgressBar currentStep={0} totalSteps={4} />
          </Box>
          <Box>
            <TextBlock fontSize={['16px', '16px', '16px', '24px']} textAlign={'left'} weight="bold" lineHeight={'24px'}>
              Configure your investment thresholds
            </TextBlock>
            <TextBlock mt={'5px'} fontSize={'14px'}>
              Let's determine your accredidation status to ensure we're following SEC investment guidelines. Don't
              worry, you can update this at any time
            </TextBlock>
          </Box>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          autoFocus={true}
          isLoading={model.loading}
          isDisabled={false}
          w={'100%'}
          rightIcon={<Icon icon="chevron-right" />}
          mt={'10px'}
          onClick={() => model.nextStep()}>
          Continue
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
